import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconListBullets = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M7.14001 7.85999C7.14001 7.44577 7.4758 7.10999 7.89001 7.10999H7.92001C8.33423 7.10999 8.67001 7.44577 8.67001 7.85999C8.67001 8.2742 8.33423 8.60999 7.92001 8.60999H7.89001C7.4758 8.60999 7.14001 8.2742 7.14001 7.85999Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11 7.10999C10.5858 7.10999 10.25 7.44577 10.25 7.85999C10.25 8.2742 10.5858 8.60999 11 8.60999H16.11C16.5242 8.60999 16.86 8.2742 16.86 7.85999C16.86 7.44577 16.5242 7.10999 16.11 7.10999H11Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.14001 12C7.14001 11.5858 7.4758 11.25 7.89001 11.25H7.92001C8.33423 11.25 8.67001 11.5858 8.67001 12C8.67001 12.4142 8.33423 12.75 7.92001 12.75H7.89001C7.4758 12.75 7.14001 12.4142 7.14001 12Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11 11.25C10.5858 11.25 10.25 11.5858 10.25 12C10.25 12.4142 10.5858 12.75 11 12.75H16.11C16.5242 12.75 16.86 12.4142 16.86 12C16.86 11.5858 16.5242 11.25 16.11 11.25H11Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.14001 16.14C7.14001 15.7258 7.4758 15.39 7.89001 15.39H7.92001C8.33423 15.39 8.67001 15.7258 8.67001 16.14C8.67001 16.5542 8.33423 16.89 7.92001 16.89H7.89001C7.4758 16.89 7.14001 16.5542 7.14001 16.14Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11 15.39C10.5858 15.39 10.25 15.7258 10.25 16.14C10.25 16.5542 10.5858 16.89 11 16.89H16.11C16.5242 16.89 16.86 16.5542 16.86 16.14C16.86 15.7258 16.5242 15.39 16.11 15.39H11Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M3.25 5.00324C3.25 3.38965 4.70504 2.25 6.28888 2.25H17.7111C19.295 2.25 20.75 3.38965 20.75 5.00324V19.0043C20.7339 20.6078 19.2889 21.75 17.7111 21.75H6.28888C4.70504 21.75 3.25 20.6104 3.25 18.9968V5.00324ZM6.28888 3.75C5.3394 3.75 4.75 4.39965 4.75 5.00324V18.9968C4.75 19.6003 5.3394 20.25 6.28888 20.25H17.7111C18.6428 20.25 19.2418 19.6051 19.25 18.9925V5.00324C19.25 4.39965 18.6606 3.75 17.7111 3.75H6.28888Z",
			fill: "currentColor"
		})
	]
});
export { SvgIconListBullets as ReactComponent };
